<template>
  <span class="button is-transition"><slot></slot></span>
</template>

<script>

export default {
  components: {
  },
  props: [],
  data () {
    return {
    }
  },
  computed: {
  },
  mounted () {
  },
  beforeDestroy () {
  },
  methods: {
  },
  filters: {
  }
}
</script>

<style lang="sass" scoped>
.button
  display: inline-flex
  justify-content: center
  align-items: center
  margin: 0 auto
  color: $white
  background-color: var(--primary-color)
  width: 272px
  height: 66px
  font-size: 18px
  padding: 21px 0
  border-radius: 4px
  &:hover
    opacity: 0.8
  +mobile
    width: 200px
    height: 55px
    font-size: 16px
    border-radius: 4px
  &.light
    background-color: $white
    color: var(--primary-color)
</style>
